import { createFormContext } from '@mantine/form';

export interface I_IconSetting {
  type: 'system' | 'custom'; // 系统 或 自定义
  // 系统图标
  index?: number;
  // 自定义图标
  url?: string;
  file?: File;
}

export type SignatureMessagesDisplayType = 'widget' | 'share' | 'desktop';

export interface I_DigitalHuman {
  backgroundColor: {
    checked: boolean;
    value: string;
  };
  image: string;
}

export interface I_UserFormValues {
  chatbotIcon: {
    icon: I_IconSetting;
    position: {
      checked: boolean;
      value: 'left' | 'right';
    };
    color: {
      checked: boolean;
      value: string;
    };
    stayPage: {
      checked: boolean;
      value: number;
    };
    iconButtonText: {
      checked: boolean;
      value: string;
    };
  };
  chatbot: {
    multiLanguageTitle?: {
      checked: boolean;
      values: {
        zh: string;
        en: string;
        ja: string;
        ko: string;
      };
    };
    welcomeMessage: {
      checked: boolean;
      value: string;
      type: string;
      multiLanguageValues: {
        zh: string;
        en: string;
        ja: string;
        ko: string;
      };
    };
    suggestedMessages: {
      checked: boolean;
      value: string;
      type: string;
      node_list: string[];
    };
    signatureMessages: {
      checked: boolean;
      value: string;
      displayType: SignatureMessagesDisplayType;
      list: {
        iconIndex: number;
        value: string;
      }[];
    };
    chatHeaderDisplay: {
      checked: boolean;
      value: string;
    };
    inputPlaceholder: {
      checked: boolean;
      value: string;
    };
    footerBrand: {
      checked: boolean;
      value: string;
    };
    answerSource: {
      checked: boolean;
    };
    widgetColor: {
      chatColor: {
        checked: boolean;
        value: string;
      };
      sendButtonColor: {
        checked: boolean;
        value: string;
      };
      userMessageColor: {
        checked: boolean;
        value: string;
      };
      botMessageColor: {
        checked: boolean;
        value: string;
      };
    };
  };
  chatbotAvatar: I_IconSetting;
  digitalHuman: I_DigitalHuman;
}

export const [UserFormProvider, useWidgetFormContext, useUserForm] = createFormContext<I_UserFormValues>();
